export const possibleErrors = {
  rules: {
    'no-console': 'error',
    'no-debugger': 'error',
  },
};
